import Path from "../../services/paths";
import DownloadXlxActions from "../actions/downloadXlxActions";
import utils from "../common/utils";
import axios from "axios";
import CustomToast from '../../util-functions/customToast.jsx'

class DownloadDPXlxMiddleware {
  static downloadXlx(
    page,
    selectedCategory,
    selectedBrand,
    selectedSku,
    selectedYear,
    weekFrom,
    weekTo,
    selectedForecast,
    selectedWeekFrom,
    selectedCOTC,
    isMonthly,
    isGreg
  ) {
    let url = `${Path.POST_DOWNLOAD_DP_XLX}?`;
    // if (page) {
    //   url += `page=${page}&`;
    // }
    if (selectedCategory) {
      url += `category=${selectedCategory}&`;
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (selectedYear) {
        url += `year=${selectedYear}&`;
    }
    if (Array.isArray(selectedCOTC)) {
      selectedCOTC.forEach(element => {
        url += `cotc=${element}&`;
      });
    }
    if (weekFrom) {
      url += `duration_from=${weekFrom}&`;
    }
    if (weekTo) {
      url += `duration_to=${weekTo}&`;
    }
    if (selectedWeekFrom) {
      url += `snapshot=${selectedWeekFrom}&`;
    }
    if (selectedForecast || selectedForecast === false) {
      url += `forecasted=${selectedForecast}&`;
    }
    if (isMonthly || isMonthly === false) {
      url += `monthly=${isMonthly}&`
    }
    if (isGreg || isGreg === false) {
      url += `is_greg=${isGreg}&`
    }

    url = url.slice(0, -1);


    return dispatch => {
      dispatch(DownloadXlxActions.downloadXlxRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
              } else {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=')+1,)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                // ToastsStore.success("Download Successful")
                CustomToast('success', 'Download Successful')
                dispatch(DownloadXlxActions.downloadXlxSuccessul(res));
              }
            })
            .catch(error => {
              CustomToast('error', 'Download Failed!')
              dispatch(DownloadXlxActions.downloadXlxFailed(error));
            });
        })
        .catch(error => {
          dispatch(DownloadXlxActions.downloadXlxFailed(error));
        });
    };
  }
}

export default DownloadDPXlxMiddleware;
